import { useEffect, useState } from "react";
import { getLogs, postFilters } from "../api_controll/apiAdmin";
import BackButton from "../components/BackButton";

function LogPage() {
  // --- STATE MANAGEMENT ---
  const [logs, setLogs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [expandedLogs, setExpandedLogs] = useState({});

  // Filter Form State
  const [filters, setFilters] = useState({
    station: "",
    date: "",
    subject: "",
    recipients: "",
  });

  // --- DATA FETCHING (INITIAL LOAD) ---
  const loadInitialData = async () => {
    setLoading(true);
    try {
      const data = await getLogs();
      setLogs(data);
      setError(null);
    } catch (err) {
      setError(err.message || "Zaznamy se nenacetly");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadInitialData();
  }, []);

  // --- FILTER HANDLERS ---
  const handleFilterChange = (e) => {
    setFilters({
      ...filters,
      [e.target.name]: e.target.value,
    });
  };

  // Trigger POST request to backend
  const handleSearch = async () => {
    setLoading(true);
    try {
      const data = await postFilters(filters);
      setLogs(data);
      setError(null);
    } catch (err) {
      setError(err.message || "Chyba při filtrování Zaznamu.");
    } finally {
      setLoading(false);
    }
  };

  // Allow hitting 'Enter' in any input box to trigger search
  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      handleSearch();
    }
  };

  // Reset filters to empty and reload all data
  const handleReset = () => {
    setFilters({ station: "", date: "", subject: "", recipients: "" });
    loadInitialData();
  };

  const toggleRow = (id) => {
    setExpandedLogs((prev) => ({ ...prev, [id]: !prev[id] }));
  };

  // --- GUARD CLAUSES ---
  if (loading && logs.length === 0) {
    return (
      <div
        style={{
          padding: "40px",
          textAlign: "center",
          fontFamily: "sans-serif",
          color: "#4a5568",
        }}
      >
        Načítání logů...
      </div>
    );
  }
  if (error && logs.length === 0) {
    return (
      <div
        style={{
          padding: "40px",
          textAlign: "center",
          fontFamily: "sans-serif",
          color: "#e53e3e",
        }}
      >
        Chyba: {error}
      </div>
    );
  }

  // --- PRE-PROCESS DATA ---
  const processedLogs = logs.map((log) => {
    let formattedDate = "N/A";
    if (log.sent_at) {
      const date = new Date(log.sent_at);
      const day = date.getDate();
      const month = date.getMonth() + 1;
      const year = date.getFullYear();
      /*const hours = date.getHours();
      const minutes = date.getMinutes().toString().padStart(2, "0");*/
      formattedDate = `${day}.${month}.${year}`; /*${hours}:${minutes}*/
    }

    let formattedRecipients = "Žádní příjemci";
    if (log.recipients) {
      try {
        const parsed =
          typeof log.recipients === "string"
            ? JSON.parse(log.recipients)
            : log.recipients;
        formattedRecipients = parsed.map((r) => r.username).join(", ");
      } catch (e) {
        formattedRecipients = "Chyba dat";
      }
    }

    let cleanSubject = log.subject || "Bez předmětu";
    if (log.station_name) {
      cleanSubject = cleanSubject
        .replace(` - ${log.station_name}`, "")
        .replace(`${log.station_name} || `, "")
        .trim();
    }

    return { ...log, formattedDate, formattedRecipients, cleanSubject };
  });

  // --- STYLING HELPERS ---
  const inputStyle = {
    padding: "8px 12px",
    borderRadius: "8px",
    border: "1px solid #e2e8f0",
    backgroundColor: "#ffffff",
    color: "#2d3748",
    fontFamily: "sans-serif",
    fontSize: "0.9rem",
    outline: "none",
    minWidth: "130px",
    flex: "1 1 auto",
  };

  // --- MAIN RENDER ---
  return (
    <div
      className="layout-body"
      style={{
        backgroundColor: "#f4f7f6",
        minHeight: "100vh",
        padding: "20px",
      }}
    >
      <main
        className="content"
        style={{ maxWidth: "1200px", margin: "0 auto" }}
      >
        <div className="empty-dashboard">
          {/* Header & Filter Bar Flex Container */}
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              flexWrap: "wrap",
              gap: "16px",
              marginBottom: "24px",
            }}
          >
            <div style={{ display: "flex", alignItems: "center", gap: "16px" }}>
              <BackButton />
              <h2
                style={{
                  margin: 0,
                  color: "#1a365d",
                  fontFamily: "sans-serif",
                  fontWeight: "bold",
                }}
              >
                Správa Zaznamu
              </h2>
            </div>

            {/* Filter Inputs & Action Buttons */}
            <div
              style={{
                display: "flex",
                gap: "8px",
                flexWrap: "wrap",
                alignItems: "center",
              }}
            >
              <input
                name="station"
                value={filters.station}
                onChange={handleFilterChange}
                onKeyDown={handleKeyDown}
                placeholder="Stanice..."
                style={inputStyle}
              />
              <input
                type="date" /*time-local*/
                name="date"
                value={filters.date}
                onChange={handleFilterChange}
                onKeyDown={handleKeyDown}
                style={inputStyle}
              />
              <input
                name="subject"
                value={filters.subject}
                onChange={handleFilterChange}
                onKeyDown={handleKeyDown}
                placeholder="Předmět..."
                style={inputStyle}
              />
              <input
                name="recipients"
                value={filters.recipients}
                onChange={handleFilterChange}
                onKeyDown={handleKeyDown}
                placeholder="Příjemce..."
                style={inputStyle}
              />

              <button
                onClick={handleSearch}
                disabled={loading}
                style={{
                  padding: "8px 16px",
                  backgroundColor: "#1a365d",
                  color: "#fff",
                  border: "none",
                  borderRadius: "8px",
                  fontWeight: "bold",
                  cursor: loading ? "not-allowed" : "pointer",
                  opacity: loading ? 0.7 : 1,
                  fontFamily: "sans-serif",
                }}
              >
                {loading ? "Hledání..." : "Filtrovat"}
              </button>

              <button
                onClick={handleReset}
                disabled={loading}
                style={{
                  padding: "8px 16px",
                  backgroundColor: "#e2e8f0",
                  color: "#4a5568",
                  border: "none",
                  borderRadius: "8px",
                  fontWeight: "bold",
                  cursor: loading ? "not-allowed" : "pointer",
                  fontFamily: "sans-serif",
                }}
              >
                Zrušit
              </button>
            </div>
          </div>

          <div
            style={{ display: "flex", flexDirection: "column", gap: "10px" }}
          >
            {processedLogs.length === 0 && !loading ? (
              <div
                style={{
                  textAlign: "center",
                  padding: "20px",
                  color: "#a0aec0",
                  fontFamily: "sans-serif",
                }}
              >
                Zadaným filtrům neodpovídají žádné záznamy.
              </div>
            ) : (
              processedLogs.map((log) => {
                const isExpanded = !!expandedLogs[log.id];

                return (
                  <div
                    key={log.id}
                    style={{
                      backgroundColor: "#ffffff",
                      borderRadius: "12px",
                      border: "1px solid #e2e8f0",
                      boxShadow: "0 1px 3px rgba(0,0,0,0.05)",
                      display: "flex",
                      flexDirection: "column",
                      fontFamily: "sans-serif",
                      overflow: "hidden",
                    }}
                  >
                    {/* Compact Clickable Header */}
                    <div
                      onClick={() => toggleRow(log.id)}
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "16px",
                        padding: "16px 20px",
                        cursor: "pointer",
                        backgroundColor: isExpanded ? "#f7fafc" : "#ffffff",
                        transition: "background-color 0.2s ease",
                      }}
                    >
                      <div
                        style={{
                          flex: 1,
                          display: "flex",
                          flexWrap: "wrap",
                          alignItems: "center",
                          gap: "12px",
                        }}
                      >
                        <strong
                          style={{
                            color: "#1a365d",
                            fontSize: "1.05rem",
                            minWidth: "140px",
                          }}
                        >
                          {log.station_name}
                        </strong>
                        <span
                          style={{
                            color: "#718096",
                            fontSize: "0.9rem",
                            whiteSpace: "nowrap",
                          }}
                        >
                          {log.formattedDate}
                        </span>
                        <span style={{ color: "#2d3748", fontWeight: "500" }}>
                          {log.cleanSubject}
                        </span>
                        <span
                          style={{
                            color: "#a0aec0",
                            fontSize: "0.85rem",
                            marginLeft: "auto",
                          }}
                        >
                          (Příjemci: {log.formattedRecipients})
                        </span>
                      </div>
                      <div style={{ color: "#a0aec0", fontWeight: "bold" }}>
                        {isExpanded ? "▲" : "▼"}
                      </div>
                    </div>

                    {/* Expandable Body (Payload) */}
                    {isExpanded && (
                      <div
                        style={{
                          padding: "16px 20px",
                          borderTop: "1px solid #e2e8f0",
                        }}
                      >
                        {log.payload_data?.prices &&
                        Array.isArray(log.payload_data.prices) ? (
                          <div
                            style={{
                              display: "flex",
                              flexWrap: "wrap",
                              gap: "8px",
                            }}
                          >
                            {log.payload_data.prices.map((item, index) => {
                              if (item.reason) {
                                const competitorName = item.station_name
                                  ? item.station_name.split(" - ")[0]
                                  : "Konkurence";
                                return (
                                  <div
                                    key={index}
                                    style={{
                                      backgroundColor: "#fff5f5",
                                      border: "1px solid #fed7d7",
                                      borderRadius: "8px",
                                      padding: "8px 12px",
                                      color: "#c53030",
                                      fontSize: "0.9rem",
                                    }}
                                  >
                                    <strong style={{ fontWeight: "bold" }}>
                                      {competitorName} ({item.price_type})
                                    </strong>
                                    <span
                                      style={{
                                        fontWeight: "bold",
                                        marginLeft: "4px",
                                      }}
                                    >
                                      [{item.reason}]:
                                    </span>
                                    <span style={{ marginLeft: "6px" }}>
                                      {item.value} {item.currency}
                                    </span>
                                    <div
                                      style={{
                                        color: "#e53e3e",
                                        fontSize: "0.8rem",
                                        marginTop: "2px",
                                      }}
                                    >
                                      (Armex: {item.armex_value} | Rozdíl:{" "}
                                      {Number(item.diff).toFixed(2)})
                                    </div>
                                  </div>
                                );
                              }

                              return (
                                <div
                                  key={index}
                                  style={{
                                    backgroundColor: "#ebf8fa",
                                    border: "1px solid #bee3f8",
                                    borderRadius: "8px",
                                    padding: "8px 12px",
                                    color: "#2a4365",
                                    fontSize: "0.9rem",
                                    display: "flex",
                                    alignItems: "center",
                                    gap: "6px",
                                  }}
                                >
                                  <strong style={{ fontWeight: "bold" }}>
                                    {item.price_type}:
                                  </strong>
                                  <span>{item.CZK} CZK</span>
                                  {item.EUR && (
                                    <span style={{ color: "#4a5568" }}>
                                      / {item.EUR} EUR
                                    </span>
                                  )}
                                </div>
                              );
                            })}
                          </div>
                        ) : (
                          <span
                            style={{ color: "#a0aec0", fontSize: "0.9rem" }}
                          >
                            Žádná data v payloadu.
                          </span>
                        )}
                      </div>
                    )}
                  </div>
                );
              })
            )}
          </div>
        </div>
      </main>
    </div>
  );
}
export default LogPage;
